import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const [companies, setCompanies] = useState(null);
  const [companyId, setCompanyIdState] = useState(localStorage.getItem("ts_company") || "");
  const [year, setYearState] = useState(Number(localStorage.getItem("ts_year")) || 2026);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/companies");
    setCompanies(data);
    return data;
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (!companies) return;
    if (!companies.find((c) => c.id === companyId)) {
      const next = companies[0]?.id || "";
      setCompanyIdState(next);
      localStorage.setItem("ts_company", next);
    }
  }, [companies, companyId]);

  const setCompanyId = (id) => {
    setCompanyIdState(id);
    localStorage.setItem("ts_company", id);
  };
  const setYear = (y) => {
    setYearState(Number(y));
    localStorage.setItem("ts_year", String(y));
  };

  const company = companies?.find((c) => c.id === companyId) || null;

  return (
    <CompanyContext.Provider value={{ companies: companies || [], loaded: companies !== null, company, companyId, setCompanyId, year, setYear, refresh }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
